import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./api";

/*
 * Server-State liegt in TanStack Query, Navigations-State in der URL
 * (TanStack Router). Die Grenze ist bewusst scharf: was der Server besitzt,
 * kommt aus dem Query-Cache; was der Nutzer teilen oder als Lesezeichen
 * ablegen können muss (Filter, Seite, Sortierung, Wert-Modus), lebt in
 * Search-Params. Kein Zustand wird in beiden gehalten.
 */

/**
 * Frischer Client — eine Instanz pro Test, damit sich Läufe nicht über den
 * Cache beeinflussen. Die App nutzt den Singleton `queryClient` unten.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 4xx sind Aussagen des Servers ("gibt es nicht", "darfst du nicht"),
        // keine Aussetzer — ein Retry brächte dieselbe Antwort und verzögert
        // nur die Anzeige. 5xx dürfen zweimal nachfassen.
        retry: (failureCount, error) => {
          if (isApiError(error) && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
